function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { getOnboardingStatus } from "../../functions/onboarding-status";
import { withRouter } from "react-router";
import PubSub from "pubsub-js";
import { Container, CssContainer } from "../../components/container";
import { Loader } from "../../components/loaders";
import Auth from "../../functions/authenticate";
import RangePicker from "../../components/range-picker";
import SiteActivityTabs from "../../components/site-activity-tabs";
import WebActivityHeader from "../web-activity/header";
import ServiceFactory from "../../service";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { RANGES } from "../sales/territory-common";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";

/*
 * §291 Phase B — in-page heat: clicks + scroll depth on the crawler's
 * page snapshot. Site Activity → Heat. NOT a recording tool — the
 * capture is coordinates, scroll depth, and short selector hints only
 * (the privacy line in JOURNEY_ANALYTICS.md), and the copy says so.
 *
 * Endpoints (probed live 2026-08-31, both stages):
 *   GET /v1/activity/heat/pages/{range}?host=        → page picker rows
 *   GET /v1/activity/heat/clicks/{range}?path&host&viewport&identifiedOnly
 *       → { cells: [{cellX 0-19, cellYDecile 0-9, clicks, topSel}] }
 *   GET /v1/activity/heat/scroll/{range}?path&host&viewport
 *       → { totalViews, deciles: [{decile, views, reachedPct}] }
 *   GET /v1/activity/heat/screenshot?path&host → presigned URLs per
 *       viewport (1h expiry — re-fetched per page pick, never cached)
 *
 * The grid maps to the SNAPSHOT: cellX = twentieths of page width,
 * cellYDecile = tenths of document height. No snapshot yet → the grid
 * renders on a neutral canvas with an honest note (the next SiteMonitor
 * crawl captures one).
 */

const heatSvc = api => {
  const S = ServiceFactory.getType(`/heat${api}`);
  return new S();
};
const safe = async (p, fb) => {
  try {
    return (await p) || fb;
  } catch (e) {
    return fb;
  }
};
const num = v => (Number(v) || 0).toLocaleString("en-US");
const VIEWPORTS = [["wide", "Desktop"], ["medium", "Tablet"], ["narrow", "Phone"]];
// selector heuristic for the dead-click flag — links/buttons/inputs are
// interactive; everything else clicked a lot is the finding.
const isInteractive = sel => /^(a[.\[#:]|a$|button|input|select|label)/.test(String(sel || ""));
class HeatViewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "loadPages", async () => {
      const rows = await safe(heatSvc(`/pages/${this.range()}`).getAsync(), []);
      if (!this._alive) return;
      const pages = Array.isArray(rows) ? rows : [];
      // ?page=host|path deep-links a page (Website Analytics › Pages › Heat →); a path-only match is
      // accepted when the host differs, and an unknown page falls back to the first one.
      let wanted = null;
      try {
        wanted = new URLSearchParams(window.location.search).get("page");
      } catch (e) {
        wanted = null;
      }
      const wantedPath = wanted && wanted.indexOf("|") >= 0 ? wanted.split("|").slice(1).join("|") : wanted;
      const fromUrl = !this.state.selKey && wanted ? pages.find(p => `${p.host || ""}|${p.path}` === wanted) || pages.find(p => p.path === wantedPath) : null;
      const selKey = fromUrl ? `${fromUrl.host || ""}|${fromUrl.path}` : this.state.selKey && pages.some(p => `${p.host || ""}|${p.path}` === this.state.selKey) ? this.state.selKey : pages[0] ? `${pages[0].host || ""}|${pages[0].path}` : null;
      this.setState({
        pages,
        selKey
      }, () => this.fetchAll());
    });
    _defineProperty(this, "fetchAll", async () => {
      const base = this.qs();
      if (!base) {
        this.setState({
          clicks: null,
          scroll: null,
          shots: null
        });
        return;
      }
      const {
        viewport,
        identifiedOnly
      } = this.state;
      this.setState({
        loading: true,
        error: null
      });
      const [clicks, scroll, shots] = await Promise.all([safe(heatSvc(`/clicks/${this.range()}?${this.qs([`viewport=${viewport}`, identifiedOnly ? "identifiedOnly=true" : ""].filter(Boolean))}`).getAsync(), null), safe(heatSvc(`/scroll/${this.range()}?${this.qs([`viewport=${viewport}`])}`).getAsync(), null), safe(heatSvc(`/screenshot?${base}`).getAsync(), null)]);
      if (!this._alive) return;
      this.setState({
        clicks,
        scroll,
        shots,
        loading: false
      });
    });
    this.state = {
      pages: null,
      selKey: null,
      mode: "clicks",
      // clicks | scroll
      viewport: "wide",
      identifiedOnly: false,
      clicks: null,
      scroll: null,
      shots: null,
      loading: false,
      error: null
    };
    this._alive = true;
  }
  range() {
    return this.props.params.range || getGlobalRange();
  }
  async componentDidMount() {
    getOnboardingStatus(false).then(st => this._alive !== false && this.setState({
      shopify: !!(st && st.shopify)
    })).catch(() => {});
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._alive || !range) return;
      const target = `/Activity/Heat/${range}`;
      if (window.location.pathname === target) {
        this.loadPages();
      } else {
        this.props.history.push(target);
      }
    });
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    this.loadPages();
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }
  componentDidUpdate(prev) {
    if (prev.params.range !== this.props.params.range) this.loadPages();
  }
  pageOf(key) {
    return (this.state.pages || []).find(p => `${p.host || ""}|${p.path}` === key) || null;
  }
  qs(extra) {
    const p = this.pageOf(this.state.selKey);
    if (!p) return null;
    const parts = [`path=${encodeURIComponent(p.path)}`];
    if (p.host) parts.push(`host=${encodeURIComponent(p.host)}`);
    return parts.concat(extra || []).join("&");
  }
  shotUrl() {
    const {
      shots,
      viewport
    } = this.state;
    if (!shots) return null;
    if (Array.isArray(shots)) {
      const hit = shots.find(s => s.viewport === viewport) || shots[0];
      return hit && (hit.url || hit.presignedUrl) || null;
    }
    return shots[viewport] || shots.url || null;
  }

  // ── the overlay ─────────────────────────────────────────────────────
  renderCanvas() {
    const {
      mode,
      clicks,
      scroll
    } = this.state;
    const url = this.shotUrl();
    const cells = clicks && clicks.cells || [];
    const maxClicks = cells.reduce((m, c) => Math.max(m, Number(c.clicks) || 0), 0);
    const deciles = scroll && scroll.deciles || [];
    const spots = mode === "clicks" ? cells.filter(c => Number(c.clicks) > 0).map((c, i) => {
      const heat = maxClicks > 0 ? (Number(c.clicks) || 0) / maxClicks : 0;
      const size = 6 + heat * 9; // % of width
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        title: `${num(c.clicks)} click${c.clicks === 1 ? "" : "s"}${c.topTxt || c.topSel ? ` · ${c.topTxt || c.topSel}` : ""}`,
        style: {
          position: "absolute",
          left: `${((Number(c.cellX) || 0) + 0.5) * 5}%`,
          top: `${((Number(c.cellYDecile) || 0) + 0.5) * 10}%`,
          width: `${size}%`,
          paddingBottom: `${size}%`,
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
          pointerEvents: "auto",
          background: heat > 0.6 ? "radial-gradient(closest-side, rgba(239,68,68,.75), rgba(245,158,11,.4), transparent)" : heat > 0.25 ? "radial-gradient(closest-side, rgba(245,158,11,.55), rgba(234,179,8,.25), transparent)" : "radial-gradient(closest-side, rgba(234,179,8,.4), transparent)"
        }
      });
    }) : [];
    const foldLines = mode === "scroll" ? deciles.filter(d => d.decile > 0 && d.decile < 10 && Number(d.reachedPct) < 99.5).slice(0, 9).map(d => /*#__PURE__*/React.createElement("div", {
      key: d.decile,
      style: {
        position: "absolute",
        left: 0,
        right: 0,
        top: `${d.decile * 10}%`,
        borderTop: "2px dashed #d97706",
        opacity: Math.max(0.35, Number(d.reachedPct) / 100)
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        position: "absolute",
        right: "8px",
        top: "-19px",
        fontSize: "10.5px",
        fontWeight: 700,
        color: "#d97706",
        background: "var(--plk-surface, #fff)",
        padding: "1px 6px",
        borderRadius: "6px"
      }
    }, Math.round(Number(d.reachedPct) || 0), "% reach here"))) : [];
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "relative",
        flex: 1,
        minWidth: "420px",
        border: "1px solid var(--plk-border, #dcdcdc)",
        borderRadius: "12px",
        overflow: "hidden",
        background: "var(--plk-surface-alt, #f5f5f5)"
      }
    }, url ? /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: "",
      style: {
        display: "block",
        width: "100%"
      }
    }) : /*#__PURE__*/React.createElement("div", {
      style: {
        width: "100%",
        paddingBottom: "130%",
        position: "relative"
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        position: "absolute",
        top: "12px",
        left: "14px",
        right: "14px",
        margin: 0
      }
    }, "No page snapshot yet \u2014 the next site crawl captures one. The ", mode === "clicks" ? "click grid" : "scroll bands", " render on a blank canvas meanwhile; positions are true to the page.")), /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        inset: 0,
        pointerEvents: "none"
      }
    }, spots, foldLines));
  }

  // ── the rail ────────────────────────────────────────────────────────
  renderRail() {
    const {
      scroll,
      clicks
    } = this.state;
    const deciles = scroll && scroll.deciles || [];
    const cells = clicks && clicks.cells || [];
    // top clicked elements: aggregate the grid by human label when the
    // backend carries topTxt (§308.2 — field pre-wired; absent today,
    // rows fall back to the selector hint exactly as before)
    const byKey = {};
    cells.forEach(c => {
      if (!c.topSel && !c.topTxt) return;
      const key = c.topTxt || c.topSel;
      const e = byKey[key] || (byKey[key] = {
        n: 0,
        sel: c.topSel,
        isTxt: !!c.topTxt
      });
      e.n += Number(c.clicks) || 0;
      if (!e.sel && c.topSel) e.sel = c.topSel;
    });
    const topSel = Object.entries(byKey).sort((a, b) => b[1].n - a[1].n).slice(0, 8);
    const railCard = {
      border: "1px solid var(--plk-border, #dcdcdc)",
      borderRadius: "12px",
      background: "var(--plk-surface, #fff)",
      padding: "14px 16px"
    };
    const h4 = {
      fontSize: "11px",
      letterSpacing: ".05em",
      color: "var(--plk-text-dim)",
      fontWeight: 700,
      margin: "0 0 10px"
    };
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: "270px",
        flex: "none",
        display: "flex",
        flexDirection: "column",
        gap: "12px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: railCard
    }, /*#__PURE__*/React.createElement("p", {
      style: h4
    }, "SCROLL DEPTH \xB7 ", (VIEWPORTS.find(([v]) => v === this.state.viewport) || [])[1]), deciles.length && (scroll.totalViews || 0) > 0 ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "3px"
      }
    }, deciles.map(d => /*#__PURE__*/React.createElement("div", {
      key: d.decile,
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "11px",
        color: "var(--plk-text-dim)"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        width: "38px"
      }
    }, d.decile * 10, "\u2013", d.decile * 10 + 10, "%"), /*#__PURE__*/React.createElement("div", {
      style: {
        height: "10px",
        borderRadius: "3px",
        background: "var(--plk-accent, #ff6358)",
        width: `${Math.max(2, (Number(d.reachedPct) || 0) * 1.7)}px`
      }
    }), /*#__PURE__*/React.createElement("span", null, Math.round(Number(d.reachedPct) || 0), "%")))) : /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "No scroll data in this range.")), /*#__PURE__*/React.createElement("div", {
      style: railCard
    }, /*#__PURE__*/React.createElement("p", {
      style: h4
    }, "TOP CLICKED ELEMENTS"), topSel.length ? topSel.map(([key, e]) => /*#__PURE__*/React.createElement("div", {
      key: key,
      title: e.sel || undefined,
      style: {
        display: "flex",
        justifyContent: "space-between",
        gap: "8px",
        fontSize: "12px",
        padding: "5px 0",
        borderBottom: "1px solid var(--plk-border, #f0f2f5)"
      }
    }, e.isTxt ? /*#__PURE__*/React.createElement("span", {
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, key) : /*#__PURE__*/React.createElement("code", {
      style: {
        fontSize: "11px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, key), /*#__PURE__*/React.createElement("b", {
      style: {
        whiteSpace: "nowrap"
      }
    }, num(e.n), !isInteractive(e.sel || "") && /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#d97706"
      }
    }, " \xB7 not a link")))) : /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "No clicks recorded in this range."), topSel.some(([, e]) => !isInteractive(e.sel || "")) && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "8px 0 0"
      }
    }, "\"Not a link\" = heavy clicks on something that isn't clickable \u2014 usually the page's highest-value fix.")), /*#__PURE__*/React.createElement("div", {
      style: {
        ...railCard,
        borderColor: "var(--plk-accent, #ff6358)"
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        ...h4,
        color: "var(--plk-accent, #ff6358)"
      }
    }, "ASK PLUNK READS THIS TOO"), /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: "12px",
        margin: "0 0 8px"
      }
    }, "Scroll depth, dead clicks, and the funnel's leaks in one answer."), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      onClick: () => {
        const p = this.pageOf(this.state.selKey);
        PubSub.publish("plunk-assistant-toggle", {
          starter: `Is the ${p ? p.path : "landing"} page working? Read its heat and scroll data.`
        });
      }
    }, "\uD83D\uDCAC Ask about this page")));
  }
  render() {
    const {
      pages,
      selKey,
      mode,
      viewport,
      identifiedOnly,
      loading
    } = this.state;
    const chip = (on, label, onClick, title) => /*#__PURE__*/React.createElement("a", {
      className: "mtf-chip" + (on ? " on" : ""),
      style: {
        cursor: "pointer"
      },
      onClick: onClick,
      title: title || ""
    }, label);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view territory-detail"
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-view"
    }, /*#__PURE__*/React.createElement(WebActivityHeader, {
      range: this.range()
    })), /*#__PURE__*/React.createElement(SiteActivityTabs, {
      range: this.range()
    }), pages === null ? /*#__PURE__*/React.createElement(Loader, null) : !pages.length ? /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "module-empty",
      style: {
        marginBottom: "6px"
      }
    }, "No in-page interaction data yet. Heat builds nightly from the clicks and scroll depth your site's tracker records: coordinates and element hints only, never keystrokes, form values or recordings."), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, this.state.shopify ? "Shopify stores: the app pixel cannot see clicks or scroll depth. Turn on the Plunk theme embed (Setup, Tracking, one click in the theme editor) and heat starts the next morning." : "Data starts accruing automatically once your site runs the current tracker; the first heat map appears the morning after.")) : /*#__PURE__*/React.createElement(Container, {
      title: "In-page heat",
      css: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px",
        flexWrap: "wrap",
        alignItems: "center",
        marginBottom: "10px"
      }
    }, (() => {
      // Filterable typeahead over the page list (can be
      // hundreds of pages) — type to narrow by host/path.
      const pageData = pages.map(p => ({
        value: `${p.host || ""}|${p.path}`,
        text: `${p.host ? `${p.host} · ` : ""}${p.path}`
      }));
      const q = (this.state.pageQuery || "").toLowerCase();
      const filtered = q ? pageData.filter(d => d.text.toLowerCase().includes(q)) : pageData;
      return /*#__PURE__*/React.createElement(ComboBox, {
        data: filtered,
        textField: "text",
        dataItemKey: "value",
        value: pageData.find(d => d.value === selKey) || null,
        onChange: e => {
          const v = e.value;
          if (!v) return;
          this.setState({
            selKey: v.value,
            pageQuery: ""
          }, () => this.fetchAll());
        },
        filterable: true,
        onFilterChange: e => this.setState({
          pageQuery: e.filter.value
        }),
        placeholder: "Search pages\u2026",
        clearButton: false,
        style: {
          width: "340px"
        }
      });
    })(), chip(mode === "clicks", "🖱 Clicks", () => this.setState({
      mode: "clicks"
    })), chip(mode === "scroll", "📜 Scroll", () => this.setState({
      mode: "scroll"
    })), /*#__PURE__*/React.createElement("span", {
      style: {
        width: "6px"
      }
    }), VIEWPORTS.map(([v, label]) => chip(viewport === v, label, () => this.setState({
      viewport: v
    }, () => this.fetchAll()))), /*#__PURE__*/React.createElement("span", {
      style: {
        width: "6px"
      }
    }), chip(identifiedOnly, "Identified only", () => this.setState({
      identifiedOnly: !identifiedOnly
    }, () => this.fetchAll()), "Recompute from sessions with a known contact — the identity join")), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 10px"
      }
    }, "Clicks and scroll depth on the crawler's page snapshot \xB7 coordinates only, no recordings \xB7 snapshot refreshes with each site crawl."), loading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "18px",
        alignItems: "flex-start",
        flexWrap: "wrap"
      }
    }, this.renderCanvas(), this.renderRail())));
  }
}
export default withRouter(HeatViewComponent);